/* eslint-disable react-hooks/exhaustive-deps */
// import React, { useState } from "react";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { removeToken } from "../utilities/authHelper";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    removeToken(() => navigate("/login"));
  }, []);
};
export default Logout;

